// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10nZ4","rootNoMargin":"styles_rootNoMargin__2f0Aj"};